import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import SomethingWentWrong from '@app/components/popups/SomethingWentWrong';
import { clearGlobalError } from '@app/store/errorSlice';
const ErrorPortal = () => {
    const dispatch = useDispatch();
    const { isErrorModalOpen } = useSelector((state) => state.error);
    const closeModal = () => {
        dispatch(clearGlobalError());
    };
    if (typeof document === 'undefined') {
        return null;
    }
    return createPortal(<SomethingWentWrong isOpen={isErrorModalOpen} closeModal={closeModal}/>, document.body);
};
export default ErrorPortal;
